export const wxCircle = (_title, _link, _img, mark) => {
    // alert('分享给朋友函数', _title, _desc, _link, _img)
    console.log('分享朋友圈函数', _title, _link, _img, mark);
    wx.updateTimelineShareData({
        title: _title || '贵燃生活', // 分享标题
        link: _link || window.location.href.split('#')[0] + '#/OPHomenew', // 分享链接
        imgUrl: _img || '', // 分享图标
        success: function() {
            console.log('SuccessonMenuShareTimeline');

            // vm.$toast("成功分享到朋友圈！")
            // vm.sheetVisible = false
            // _that.joinShare(_that);
        },
        complete: function() {
            console.log('分享完成');
        },
        cancel: function() {
            // vm.$toast("分享失败，您取消了分享！")
            // vm.sheetVisible = false
        },
        fail: function(e) {
            console.log(e);
        }
    });
    // wx.onMenuShareTimeline({
    //     title: _title || '贵燃生活', // 分享标题
    //     link: _link || window.location.href.split('#')[0] + '#/OPHomenew', // 分享链接
    //     imgUrl: _img || '', // 分享图标
    //     success: function() {
    //         console.log('SuccessonMenuShareTimeline');

    //         // vm.$toast("成功分享到朋友圈！")
    //         // vm.sheetVisible = false
    //         // _that.joinShare(_that);
    //     },
    //     complete: function() {
    //         console.log('分享完成');
    //     },
    //     cancel: function() {
    //         // vm.$toast("分享失败，您取消了分享！")
    //         // vm.sheetVisible = false
    //     },
    //     fail: function(e) {
    //         console.log(e);
    //     }
    // });
};
export const wxFriends = (_title, _desc, _link, _img) => {
    wx.updateAppMessageShareData({
        title: _title, // 分享标题
        desc: _desc, // 分享描述
        link: _link, // 分享链接
        imgUrl: _img, // 分享图标
        success: function() {
            console.log('successupdateAppMessageShareData');

            // vm.$toast("成功分享给朋友！")
            // vm.sheetVisible = false
            // _that.joinShare(_that);
        },
        complete: function() {
            console.log('分享完成');
        },
        cancel: function() {
            // vm.$toast("分享失败，您取消了分享！")
            // vm.sheetVisible = false
        }
    });
};
